/* This file was auto generated by "illustrations-tool" */
import { DEV } from 'esm-env';
import createSvgIllustration from '../createSvgIllustration';
export default createSvgIllustration(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={175}
    height={130}
    fill="none"
    viewBox="0 0 175 130"
  >
    <path
      fill="#C4D4FD"
      fillRule="evenodd"
      d="M113.8 54.8a33.6 33.6 0 0 0-53.2-31.4 33.5 33.5 0 1 0 53.2 31.4M79.2 76.3l-3.4-.2a24.8 24.8 0 0 1 6.8-49 24.7 24.7 0 0 1-3.4 49.2m49.1 25.8-1.2-1.5c-.8-1-2.2-1.1-3.2-.3l-4.9 4v.1l2.6 3.2a4.4 4.4 0 0 0 6.4.6c1.7-1.5 1.7-4.3.3-6.1M101.6 79q2.7-2 4.9-4.4l13.3 16.3c.9 1.2.7 2.8-.4 3.8l-4.6 3.8-14.9-18.3z"
      className="bg"
      clipRule="evenodd"
    />
    <path
      fill="#2A64F6"
      fillRule="evenodd"
      d="m124.8 95.7 5.1 6.3a7.6 7.6 0 0 1-.4 9.9 7 7 0 0 1-5.3 2l-.5-.1q-3-.4-4.9-2.8l-20-24.5a5.4 5.4 0 0 0-6.3-1.6 36 36 0 0 1-18.8 2.6A36.6 36.6 0 0 1 42 48.6 36 36 0 0 1 80.4 15a36.2 36.2 0 0 1 28.7 55.7c-1.2 2-1.1 4.5.4 6.3l10.9 13.3c.7.9 2 1 2.8.3l4.3-3.6a3 3 0 0 1-.4 4.2l-2 1.7c-.9.7-1 2-.3 2.8m-6.9 7.1 5.2-4.3-1.9-2.4-5.2 4.4c-.6.5-.7 1.5-.2 2.1s1.5.7 2.1.2M45.2 46.7a33.5 33.5 0 0 0 53.2 31.4 33.4 33.4 0 1 0-40.2-53.4 33 33 0 0 0-13 22M105 76.1a32 32 0 0 1-6.3 5.4L113 99l4.4-3.7c1-.9 1.2-2.5.3-3.6zm18.6 34.6q2.2.4 3.7-1c1.6-1.4 1.6-4.1.3-5.8l-1.2-1.5c-.8-.9-2.1-1-3-.3l-4.8 3.9 2.5 3.1q1 1.3 2.5 1.6M81.9 25.4a26.2 26.2 0 1 0-3.7 52.2c12.9 0 24.1-9.5 25.9-22.6a26 26 0 0 0-22.2-29.6m19.4 29.1a23.3 23.3 0 0 1-26.2 19.8 23.2 23.2 0 0 1 3.2-46.2q1.5 0 3 .2h.2a23.3 23.3 0 0 1 19.8 26.2M80.6 35.1l.4-3a20 20 0 0 1 13.8 8.8c.4.7.2 1.7-.6 2.1q-1.2.6-2-.5c-2.6-4-6.8-6.7-11.6-7.4M96 48.4zq-1.3.2-1.6-1.1l-.1-.3q-.2-1.2.9-1.7h.1c.8-.3 1.7.2 1.9 1v.2l.1.1c.2.8-.4 1.7-1.2 1.8"
      className="fg"
      clipRule="evenodd"
    />
  </svg>,
  DEV ? 'SearchIllustration' : '',
);
